define( function() {
	return ( /<([\w:-]+)/ );
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/manipulation/var/rtagName.js
// module id = 548
// module chunks = 352